import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// @ts-ignore - css side-effect; styles provided via Tailwind CDN + full <style> emulation in index.html (postcss noop for win32)
import './styles.css'
import { Toaster } from 'sonner'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster position="top-center" richColors closeButton />
  </React.StrictMode>
)
